import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { Button, ModalBody } from "reactstrap";
import { useSelector } from "react-redux";
import CloudStorage from "../../../../CloudStorage/CloudStorage";

export default function ModelLanguage({
  formData,
  setFormData,
  setModalLanguege,
}) {

  const languagelist = useSelector(
    ({ categary: { languagelist } }) => languagelist,
  );

  const filteredLanguage = languagelist?.filter(language => language.id == formData?.language_id);

  const filteredlan = filteredLanguage?.length > 0 ? {
    value: filteredLanguage[0].id,
    label: filteredLanguage[0].title
  } : {};
  const [language, setLanguege] = useState("");
  const [selectLanguage, setselectLangauge] = useState(filteredlan ? filteredlan : formData.languageindex);
  const [tempLanguage, settempLanguage] = useState(filteredlan ? filteredlan : formData.languageindex);

  useEffect(() => {
    setLanguege(languagelist);
  }, [languagelist]);



  const handleValues = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      language_id: tempLanguage.value,
      languageindex: tempLanguage,
    }));
    setselectLangauge(tempLanguage);
    setModalLanguege((state) => !state);
  };

  return (
    <>
      <button
        onClick={() => setModalLanguege((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <h4>Edit Language</h4>
        <div className="form-group">
          <label>Select Language</label>
          <ReactSelect
            options={
              Array.isArray(language) &&
              language.map((lang) => ({ value: lang.id, label: lang.title }))
            }
            placeholder={"Select"}
            value={tempLanguage}
            onChange={(options) => {
              if (options) {
                settempLanguage(options);
              }
            }}
          />
        </div>
      </ModalBody>
      <div className="modal-footer mt-3">
        <button className="btn" onClick={handleValues} disabled={!tempLanguage}>
          Save
        </button>
      </div>
    </>
  );
}
